export default __webpack_public_path__ + "static/media/login-card-weed.76671d1c.png";